import { SxProps, Theme } from '@mui/material';
import TableBody from '@mui/material/TableBody';
import * as React from 'react';
import { FunctionComponent } from 'react';
import { BasicHeadCell } from '../../../models/BasicTable/BasicTableProps';
import { RowItems } from '../../../models/TableProps';
import { TableContentWrapper } from '../Table/components/TableContentWrapper';
import { BasicTableHead } from './BasicTableHead';

export const BasicTable = <T, S>(props: BasicTableProps<T, S>) => {
    const {
        tableHeadSettings,
        component,
        fullList,
        handleChange,
        handleEvent,
        wrapperStyles,
        wrapperRef,
        onWrapperScroll,
    } = props;

    return (
        <TableContentWrapper
            wrapperStyles={wrapperStyles}
            wrapperRef={wrapperRef}
            onWrapperScroll={onWrapperScroll}
        >
            <BasicTableHead<S>
                headContent={tableHeadSettings.headContent}
                translateNs={tableHeadSettings.translateNs}
                translatePrefix={tableHeadSettings.translatePrefix}
            />
            <TableBody sx={{ width: '100%' }}>
                {fullList?.map((row, index) => {
                    return React.createElement(component, {
                        key: index,
                        row: row,
                        index: index,
                        handleChange: handleChange,
                        handleEvent: handleEvent,
                    });
                })}
            </TableBody>
        </TableContentWrapper>
    );
};

interface BasicTableProps<T, S> {
    fullList: T[];
    component: FunctionComponent<RowItems<T>>;
    tableHeadSettings: {
        headContent: BasicHeadCell<S>[];
        translateNs: string;
        translatePrefix: string;
    };
    handleChange?: (props: any) => void;
    handleEvent?: (props: any) => void;
    wrapperStyles?: SxProps<Theme>;
    wrapperRef?: React.Ref<HTMLDivElement>;
    onWrapperScroll?: React.UIEventHandler<HTMLDivElement>;
    loading?: boolean;
}
